import { apiServer } from "../config/appConfig";
import axios from "axios";

const defaultUrl = () => {
  return "/v1/nextoken/admin"
}

const setHeadersToken = (token) => {
  return {
    "Authorization" : token
  }
}

const loginService = {

  login(data) {
    return axios({
      method: "post",
      url: apiServer + defaultUrl() + "/login",
      crossOrigin: true,
      data: data
    })
  },

  logout(token) {
    return axios({
      method: "get",
      url: apiServer + defaultUrl() + "/logout",
      headers: setHeadersToken(token),
      crossOrigin: true,
    })
  }

}

export default loginService;